import { render, staticRenderFns } from "./Zhichi.vue?vue&type=template&id=76ad29f5"
import script from "./Zhichi.vue?vue&type=script&lang=js"
export * from "./Zhichi.vue?vue&type=script&lang=js"
import style0 from "./Zhichi.vue?vue&type=style&index=0&id=76ad29f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports